/**
 * Optimiciti API Specification
 * Welcome to the Beta release of the Optimiciti API. This API allows registered users to make direct calls to our optimization solvers via a web request.  Use of the API requires acceptance of our terms of service.  Some useful links: - [Optimiciti Homepage](https://optimiciti.com) - [Optimiciti API Access Plans](https://optimiciti.com/pricing)
 *
 * The version of the OpenAPI document: 0.0.2
 * Contact: api@optimiciti.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The TravelCostResponsesInner model module.
 * @module model/TravelCostResponsesInner
 * @version 0.0.2
 */
class TravelCostResponsesInner {
    /**
     * Constructs a new <code>TravelCostResponsesInner</code>.
     * @alias module:model/TravelCostResponsesInner
     * @param fromLocationId {String} The locationId of the origin location for this travel cost
     * @param toLocationId {String} The locationId of the destination location for this travel cost.
     */
    constructor(fromLocationId, toLocationId) { 
        
        TravelCostResponsesInner.initialize(this, fromLocationId, toLocationId);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, fromLocationId, toLocationId) { 
        obj['fromLocationId'] = fromLocationId;
        obj['toLocationId'] = toLocationId;
        obj['status'] = 's';
    }

    /**
     * Constructs a <code>TravelCostResponsesInner</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/TravelCostResponsesInner} obj Optional instance to populate.
     * @return {module:model/TravelCostResponsesInner} The populated <code>TravelCostResponsesInner</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new TravelCostResponsesInner();

            if (data.hasOwnProperty('fromLocationId')) {
                obj['fromLocationId'] = ApiClient.convertToType(data['fromLocationId'], 'String');
            }
            if (data.hasOwnProperty('toLocationId')) {
                obj['toLocationId'] = ApiClient.convertToType(data['toLocationId'], 'String');
            }
            if (data.hasOwnProperty('fromLocationName')) {
                obj['fromLocationName'] = ApiClient.convertToType(data['fromLocationName'], 'String');
            }
            if (data.hasOwnProperty('toLocationName')) {
                obj['toLocationName'] = ApiClient.convertToType(data['toLocationName'], 'String');
            }
            if (data.hasOwnProperty('vehicleTypeId')) {
                obj['vehicleTypeId'] = ApiClient.convertToType(data['vehicleTypeId'], 'String');
            }
            if (data.hasOwnProperty('vehicleType')) {
                obj['vehicleType'] = ApiClient.convertToType(data['vehicleType'], 'String');
            }
            if (data.hasOwnProperty('duration')) {
                obj['duration'] = ApiClient.convertToType(data['duration'], 'Number');
            }
            if (data.hasOwnProperty('distance')) {
                obj['distance'] = ApiClient.convertToType(data['distance'], 'Number');
            }
            if (data.hasOwnProperty('cost')) {
                obj['cost'] = ApiClient.convertToType(data['cost'], 'Number');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'String');
            }
            if (data.hasOwnProperty('errorMessage')) {
                obj['errorMessage'] = ApiClient.convertToType(data['errorMessage'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>TravelCostResponsesInner</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>TravelCostResponsesInner</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of TravelCostResponsesInner.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['fromLocationId'] && !(typeof data['fromLocationId'] === 'string' || data['fromLocationId'] instanceof String)) {
            throw new Error("Expected the field `fromLocationId` to be a primitive type in the JSON string but got " + data['fromLocationId']);
        }
        // ensure the json data is a string
        if (data['toLocationId'] && !(typeof data['toLocationId'] === 'string' || data['toLocationId'] instanceof String)) {
            throw new Error("Expected the field `toLocationId` to be a primitive type in the JSON string but got " + data['toLocationId']);
        }
        // ensure the json data is a string
        if (data['fromLocationName'] && !(typeof data['fromLocationName'] === 'string' || data['fromLocationName'] instanceof String)) {
            throw new Error("Expected the field `fromLocationName` to be a primitive type in the JSON string but got " + data['fromLocationName']);
        }
        // ensure the json data is a string
        if (data['toLocationName'] && !(typeof data['toLocationName'] === 'string' || data['toLocationName'] instanceof String)) {
            throw new Error("Expected the field `toLocationName` to be a primitive type in the JSON string but got " + data['toLocationName']);
        }
        // ensure the json data is a string
        if (data['vehicleTypeId'] && !(typeof data['vehicleTypeId'] === 'string' || data['vehicleTypeId'] instanceof String)) {
            throw new Error("Expected the field `vehicleTypeId` to be a primitive type in the JSON string but got " + data['vehicleTypeId']);
        }
        // ensure the json data is a string
        if (data['vehicleType'] && !(typeof data['vehicleType'] === 'string' || data['vehicleType'] instanceof String)) {
            throw new Error("Expected the field `vehicleType` to be a primitive type in the JSON string but got " + data['vehicleType']);
        }
        // ensure the json data is a string
        if (data['status'] && !(typeof data['status'] === 'string' || data['status'] instanceof String)) {
            throw new Error("Expected the field `status` to be a primitive type in the JSON string but got " + data['status']);
        }
        // ensure the json data is a string
        if (data['errorMessage'] && !(typeof data['errorMessage'] === 'string' || data['errorMessage'] instanceof String)) {
            throw new Error("Expected the field `errorMessage` to be a primitive type in the JSON string but got " + data['errorMessage']);
        }

        return true;
    }


}

TravelCostResponsesInner.RequiredProperties = ["fromLocationId", "toLocationId"];

/**
 * The locationId of the origin location for this travel cost
 * @member {String} fromLocationId
 */
TravelCostResponsesInner.prototype['fromLocationId'] = undefined;

/**
 * The locationId of the destination location for this travel cost.
 * @member {String} toLocationId
 */
TravelCostResponsesInner.prototype['toLocationId'] = undefined;

/**
 * The name of the origin location for this travel cost.
 * @member {String} fromLocationName
 */
TravelCostResponsesInner.prototype['fromLocationName'] = undefined;

/**
 * The name of the destination location for this travel cost.
 * @member {String} toLocationName
 */
TravelCostResponsesInner.prototype['toLocationName'] = undefined;

/**
 * The vehicleTypeId for this travel cost. If null, then the travel cost will apply to all vehicle types.
 * @member {String} vehicleTypeId
 */
TravelCostResponsesInner.prototype['vehicleTypeId'] = undefined;

/**
 * The name of the vehicle type for this travel cost. If null, then the travel cost will apply to all vehicle types.
 * @member {String} vehicleType
 */
TravelCostResponsesInner.prototype['vehicleType'] = undefined;

/**
 * The travel duration between these two locations.
 * @member {Number} duration
 */
TravelCostResponsesInner.prototype['duration'] = undefined;

/**
 * The travel distance between these two locations.
 * @member {Number} distance
 */
TravelCostResponsesInner.prototype['distance'] = undefined;

/**
 * The cost of travel between these two locations.
 * @member {Number} cost
 */
TravelCostResponsesInner.prototype['cost'] = undefined;

/**
 * The status of the travel cost calculation. This will be \"s\" for success, \"e\" for error, and \"w\" for warning (i.e. calculated with a fallback method).
 * @member {module:model/TravelCostResponsesInner.StatusEnum} status
 * @default 's'
 */
TravelCostResponsesInner.prototype['status'] = 's';

/**
 * If an error was encountered during the calculation of this travel cost, this field will contain a human-readable message describing the error. If no error was encountered, this field will be null.
 * @member {String} errorMessage
 */
TravelCostResponsesInner.prototype['errorMessage'] = undefined;





/**
 * Allowed values for the <code>status</code> property.
 * @enum {String}
 * @readonly
 */
TravelCostResponsesInner['StatusEnum'] = {

    /**
     * value: "s"
     * @const
     */
    "s": "s",

    /**
     * value: "e"
     * @const
     */
    "e": "e",

    /**
     * value: "w"
     * @const
     */
    "w": "w"
};



export default TravelCostResponsesInner;

